/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-22T11:11:19+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-22T11:12:27+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * ALegendMain - …
**/
class ALegendMain extends Component {
  render() {
    const {
      legendStyle,
      ...props
    } = this.props;

    return (
      <legend
        {...props}
        className={`a-legend a-legend-${legendStyle}`}
      />
    );
  }
}

ALegendMain.propTypes = {
  /**
     * legendStyle should be of "main" of "green"
     */
  legendStyle: PropTypes.string,
};
ALegendMain.defaultProps = {
  legendStyle: 'main',
};
export default ALegendMain;

